import { render, staticRenderFns } from "./ChannelTable.vue?vue&type=template&id=116f71e8&scoped=true&"
import script from "./ChannelTable.vue?vue&type=script&lang=js&"
export * from "./ChannelTable.vue?vue&type=script&lang=js&"
import style0 from "./ChannelTable.vue?vue&type=style&index=0&id=116f71e8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116f71e8",
  null
  
)

export default component.exports